import { render, staticRenderFns } from "./OrdersFBATable.vue?vue&type=template&id=75399820&scoped=true"
import script from "./OrdersFBATable.vue?vue&type=script&lang=js"
export * from "./OrdersFBATable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75399820",
  null
  
)

export default component.exports